//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetch, post } from '@/utils/api'
import '@/common/qwebchannel'
import userSessionUtils from '@/common/userSessionUtils'
import config from 'config'
import * as service from '@/service/service'

export default {
	name: 'App',
	data() {
		return {
			isRouterAlive: true,
			theme: '',
			verify_code:"178178"
		}
	},
	mounted() {
		if (window.qt) {
			// this.initQwebchannel()
			this.fetchVerifyCode()
		}

		let theme = this.getQueryVariable('theme')
		if (theme == 'gray' || theme == 'night') {
			this.theme = 'night'
		} else {
			this.theme = theme
		}
	},
	methods: {
		 // 查询验证码
		 fetchVerifyCode(){
			var $this = this
			service.fetchSdxMatch({enum_no:"pc_num"}).then(res=>{
					if(res.error_no ==0){
						let results = res.results;
						results.forEach(item=>{
								if(item['item_name']=='pc_num_value'){
									$this.verify_code = item['item_value']
								}
						})
						$this.initQwebchannel()
					}else{
						$this.initQwebchannel()
					}
			})
		},
		initQwebchannel() {
			var $this = this
			new QWebChannel(qt.webChannelTransport, function (channel) {
				window.QtSubmit = channel.objects.QtSubmit

				// window.QtSubmit.JSIPcSendToWebTest.connect(function (str) {
				// 	alert("原生消息接收： " + str);
				// });

				// 这是给客户端发送消息的方法，使用时挪到需要调用的地方
				if (window.QtSubmit) {
					// alert('3:'+ window.QtSubmit)

					// window.QtSubmit.JSIWebCallPcTest("12345");

					/**
					 * @brief 响应request
					 * @param request_serial_no 响应的请求号
					 * @param respond_json_str 响应串
					 * error_code: 0 no_error, 1 响应超时, ……
					 *资金帐号、手机号、登录token、终端信息：终端类型、终端版本、操作系统(参考APP罗列,额外3001需要信息按app模式传递)
					 * {
					 *  "error_code":"0",
					 *  "error_msg":"no_error",
					 *  "login_session":{
					 *     "capital_account":"004****201"
					 * --phone_no
					 * login_token
					 * channel_id
					 * ht_id
					 * mac
					 * device_type "PC/Mobile"|"Desktop/Laptop/Mobile"
					 * os_type     "mac/windows"
					 * os_version
					 * app_version
					 *  }
					 * }
					 */
					window.QtSubmit.JSISignalLoginSessionResponded.connect(function (request_serial_no, respond_json_str) {
						// 需要移除遮罩层
						$this.showload(false)
						// 判断request_serial_no与本地存储
						let loginuuidsave = userSessionUtils.getInfoSStorage('loginuuid')

						if (loginuuidsave && loginuuidsave == request_serial_no) {
							if (respond_json_str) {
								respond_json_str = JSON.parse(respond_json_str)
								if ('0' == respond_json_str.error_code) {
									if (respond_json_str && respond_json_str.login_session) {
										let login_session = respond_json_str.login_session

										sessionStorage.setItem('login_session_info', JSON.stringify(login_session))
										// 测试代码 以下2行
										// if (true) {
										// 	if (true) {
										// 		let login_session = respond_json_str

										let paramMap = {}
										paramMap['auth_type'] = '1'
										// paramMap['verify_code'] = config.global.checkCode
										paramMap['verify_code'] = $this.verify_code
										paramMap['mobileKey'] = ''
										paramMap['mobile_code'] = ''
										paramMap['account_type'] = 'M'
										paramMap['trade_pwd'] = ''
										paramMap['auth_pwd'] = ''
										paramMap['client_hdd'] = login_session['client_hdd']
										paramMap['client_mac'] = login_session['client_mac']

										paramMap['client_mobile'] = ''
										paramMap['login_account'] = login_session['login_account']
										paramMap['3rd_login_token'] = login_session['login_token']
										paramMap['remark'] = login_session['client_id']

										// paramMap['auth_type'] = '2'
										paramMap['ter_type_desc'] = login_session['ter_type']
										paramMap['ter_type'] = $this.mateType(login_session['ter_type'])

										paramMap['client_os_ver'] = login_session['client_os_ver']

										//paramMap['account_type'] = config.global.account_type
										paramMap['net_cate'] = config.global.net_cate

										paramMap['sourceid'] = 'ispc'

										// let data = {
										// 	ter_type: '20',
										// 	client_ver: '200',
										// 	client_os_ver: 'ios 8.0',
										// 	account_type: '4',
										// 	login_account: this.userId,
										// 	trade_pwd: 'encrypt_rsa:' + window.rsa.encrypt(this.tradePassword),
										// 	auth_type: '1',
										// 	net_cate: '1',
										// 	auth_pwd: 'encrypt_rsa:' + window.rsa.encrypt(this.tradePassword),
										// 	mobileKey: '0.999999999999999999',
										// 	mobile_code: '989898',
										// 	verify_code: '178178',
										// 	client_mobile: this.userPhone
										// }
										service
											.userLogin(paramMap)
											.then((resultVo) => {
												console.log(resultVo)
												if (0 == resultVo.error_no) {
													let results = resultVo.results
													if (results && results.length > 0) {
														userSessionUtils.saveSessionUserInfo(results[0])
														$this.reload()
														if (this.$route.query.to) {
															this.$router.push({
																path: this.$route.query.to,
															})
														} else {
															this.$router.push({
																path: '/',
															})
														}
													} else {
														let alertTips = '登录信息返回为空[JSISignalSetLoginSession]'
														this.$alert.show({
															title: '提示',
															content: alertTips,
															onConfirm() {},
														})
													}
												} else {
													let alertTips = resultVo.error_info
													this.$alert.show({
														title: '提示',
														content: alertTips,
														onConfirm() {},
													})
												}
											})
											.catch((err) => {
												console.log(err)
											})
									}
								} else {
									let alertTips = respond_json_str.error_msg
									this.$alert.show({
										title: '提示',
										content: alertTips,
										onConfirm() {},
									})
								}
							} else {
								let alertTips = '相应登录信息异常:' + request_serial_no + '|' + loginuuidsave
								this.$alert.show({
									title: '提示',
									content: alertTips,
									onConfirm() {},
								})
							}
						}
					})

					/**
					 * @brief 设置登录Session
					 * @param session_json_str 登录Session内容
					 * 1. 没有login_session节点代表注销
					 * 2. 示例：
					 * "login_session":{
					 *     "capital_account":"004****201"
					 * --phone_no
					 * login_token
					 * channel_id
					 * ht_id
					 * mac
					 * device_type "PC/Mobile"|"Desktop/Laptop/Mobile"
					 * os_type     "mac/windows"
					 * os_version
					 * app_version
					 *  }
					 */
					window.QtSubmit.JSISignalSetLoginSession.connect(function (session_json_str) {
						console.log(session_json_str)
						// 设置会话信息的方法
						if (session_json_str) {
							let login_session = JSON.parse(session_json_str)

							sessionStorage.setItem('login_session_info', session_json_str)
							let paramMap = {}
							paramMap['auth_type'] = '1'
							// paramMap['verify_code'] = config.global.checkCode
							paramMap['verify_code'] = $this.verify_code
							paramMap['mobileKey'] = ''
							paramMap['mobile_code'] = ''
							paramMap['account_type'] = 'M'
							paramMap['trade_pwd'] = ''
							paramMap['auth_pwd'] = ''
							paramMap['client_hdd'] = login_session['client_hdd']
							paramMap['client_mac'] = login_session['client_mac']

							paramMap['client_mobile'] = ''
							paramMap['login_account'] = login_session['login_account']
							paramMap['3rd_login_token'] = login_session['login_token']
							paramMap['remark'] = login_session['client_id']

							// paramMap['auth_type'] = '2'
							paramMap['ter_type_desc'] = login_session['ter_type']
							paramMap['ter_type'] = $this.mateType(login_session['ter_type'])

							paramMap['client_os_ver'] = login_session['client_os_ver']

							//paramMap['account_type'] = config.global.account_type
							paramMap['net_cate'] = config.global.net_cate

							paramMap['sourceid'] = 'ispc'

							// let data = {
							// 	ter_type: '20',
							// 	client_ver: '200',
							// 	client_os_ver: 'ios 8.0',
							// 	account_type: '4',
							// 	login_account: this.userId,
							// 	trade_pwd: 'encrypt_rsa:' + window.rsa.encrypt(this.tradePassword),
							// 	auth_type: '1',
							// 	net_cate: '1',
							// 	auth_pwd: 'encrypt_rsa:' + window.rsa.encrypt(this.tradePassword),
							// 	mobileKey: '0.999999999999999999',
							// 	mobile_code: '989898',
							// 	verify_code: '178178',
							// 	client_mobile: this.userPhone
							// }
							service.userLogin(paramMap).then((resultVo) => {
								if (0 == resultVo.error_no) {
									let results = resultVo.results
									if (results && results.length > 0) {
										if ($this.checkLogin == false) {
											userSessionUtils.saveSessionUserInfo(results[0])
											$this.reload()
										} else {
											userSessionUtils.saveSessionUserInfo(results[0])
										}
									} else {
										let alertTips = '登录信息返回为空[JSISignalSetLoginSession]'
										$this.$alert.show({
											title: '提示',
											content: alertTips,
											onConfirm() {},
										})
									}
								} else {
									let alertTips = resultVo.error_info
									$this.$alert.show({
										title: '提示',
										content: alertTips,
										onConfirm() {},
									})
								}
							})
						} else if (session_json_str == '') {
							// 退出登录
							$this.showload(false)
							userSessionUtils.filterLoginOut()
							$this.reload()
						}
					})

					/**
					 * @brief 设置皮肤
					 * @param theme day|night
					 */
					window.QtSubmit.JSISignalSetThemeChanged.connect(function (theme) {
						console.log(theme)
						// this.theme = 'night'
						this.theme = theme
						// 设置皮肤的具体方法
					})

					// /**
					//  * @brief 请求登录信息
					//  * @return 请求号
					//  */
					// window.QtSubmit.JSIRequestLoginSession();
					//
					// /**
					//  * @brief 显示网厅
					//  * @param url 跳转至的URL
					//  * @return 是否成功
					//  */
					// window.QtSubmit.JSIShowOnlineBusinessHallView(url);

					/**
					 * @brief 商城初始化时调用
					 *   设置主题、登录会话
					 */
					window.QtSubmit.JSIOnMallInit()
				}
			})
		},
		reload() {
			this.isRouterAlive = false
			this.$nextTick(function () {
				this.isRouterAlive = true
			})
		},
		mateType(value) {
			let val = ''
			if (typeof value == 'string') {
				val = value.toLowerCase()
			} else {
				return value
			}
			if (val.indexOf('windows') > -1) {
				return '40'
			} else if (val.indexOf('mac') > -1) {
				return '41'
			} else {
				return '61'
			}
		},
		getQueryVariable(variable) {
			var query = window.location.search.substring(1)
			var vars = query.split('&')
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split('=')
				if (pair[0] == variable) {
					return pair[1]
				}
			}
			return false
		},
	},
	watch: {
		theme(val, oldval) {
			window.localStorage.setItem('theme', val)
		},
	},
}



// WEBPACK FOOTER //
// ./src/App.vue